import styled, { css, CSSObject, keyframes } from 'styled-components'

const keyframesShimmer = keyframes`
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
`

const shimmerAnimation = css`
  ${({ theme }) => css`
    background: linear-gradient(
      to right,
      ${theme.colors.coolGray.cool100} 8%,
      ${theme.colors.coolGray.cool150} 18%,
      ${theme.colors.coolGray.cool100} 33%
    );
  `}
  background-size: 1200px 100%;
  animation: ${keyframesShimmer} 3.5s infinite linear;
`

export const TypographyShimmer = styled.span<{ $width: CSSObject['width'] }>`
  display: inline-block;
  width: ${({ $width }) => $width};
  height: 1em;
  border-radius: 4px;
  ${shimmerAnimation};
`
